import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'

export function EFCanlendar() {
  const isDark = useAppSelector(isDarkTheme)
  return (
    <svg
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.75 3.5C19.5449 3.5 21 4.95507 21 6.75V18.25C21 20.0449 19.5449 21.5 17.75 21.5H6.25C4.45507 21.5 3 20.0449 3 18.25V6.75C3 4.95507 4.45507 3.5 6.25 3.5H17.75ZM19.5 9H4.5V18.25C4.5 19.2165 5.2835 20 6.25 20H17.75C18.7165 20 19.5 19.2165 19.5 18.25V9ZM17.75 5H6.25C5.2835 5 4.5 5.7835 4.5 6.75V7.5H19.5V6.75C19.5 5.7835 18.7165 5 17.75 5Z'
        fill={isDark ? 'var(--color-dark-theme)' : '#335173'}
      />
    </svg>
  )
}
